<script>
  import Chartline from "./ChartDefaultMD.svelte";
  import ToolsSpinner from "../ihm/ToolsSpinner.svelte";
  import { onMount } from "svelte";
  import { urlServeur } from "../conf";

  let promiseAll;
  let promisePerso;
  let axeTxfAll;
  let serieTxfAll;
  let axeTxfPerso;
  let serieTxfPerso;

  const fecthDataAll = async () => {
    const response = await fetch(
      urlServeur + "/api/immeubles/graphTxFonciere/0"
    ); // Ttes les taxes
    const result = await response.json();

    axeTxfAll = result.payload.axe_fonciere;
    axeTxfAll = axeTxfAll.slice(1, -1).split(","); // supprimer les [], et convertie chaine en tableau
    serieTxfAll = JSON.parse(result.payload.serie_fonciere);
  };

  const fecthDataPerso = async () => {
    const response = await fetch(
      urlServeur + "/api/immeubles/graphTxFonciere/1"
    ); // Ttes les taxes
    const result = await response.json();

    axeTxfPerso = result.payload.axe_fonciere;
    axeTxfPerso = axeTxfPerso.slice(1, -1).split(","); // supprimer les [], et convertie chaine en tableau
    serieTxfPerso = JSON.parse(result.payload.serie_fonciere);
  };

  onMount(async () => {
    promiseAll = fecthDataAll();
    promisePerso = fecthDataPerso();
  });
</script>

<div class="chart-container">
  <div class="pie-chart-container">
    {#await promiseAll}
      <ToolsSpinner />
    {:then number}
      <h3>Ttes Tx. F</h3>
      <Chartline
        chartType={"line"}
        chartDatasets={serieTxfAll}
        chartDataLabels={axeTxfAll}
        chartLabelLine={"Ttes Tx. F"}
      />
    {/await}

    {#await promisePerso}
      <p />
    {:then number}
      <h3>Tx.F Perso</h3>
      <Chartline
        chartType={"line"}
        chartDatasets={serieTxfPerso}
        chartDataLabels={axeTxfPerso}
        chartLabelLine={"Tx.F Perso"}
      />
    {/await}
  </div>
</div>

<style>
  .chart-container {
   align : "center";
  }

  .pie-chart-container {
    height: 360px;
    width: 360px;
    float: left;
  }
</style>
